import "@hakili/ui/styles.css";
import "@hakili/ui/bank-theme.css";

import { createRoot } from "react-dom/client";

import { App } from "./App.js";

/**
 * The entry point of `bank-web`, `P0-UIK-020`, and , since round 189 , the
 * mount `P1-BKW-001` promised.
 *
 * **What this file does, and what it deliberately does not.** It finds the
 * mount point and opens a React root on it. That is the whole of it, and the
 * restraint is the point rather than an omission.
 *
 * **It used to render `null`, and the comment that said so was right.**
 * `P0-UIK-020`'s scope was *"a bundler, an entry point and a `build` script per
 * app"*, and inventing a session gate inside an infrastructure item would have
 * been product written in the wrong place. That comment ended with the sentence
 * this round is: *"when the screens' items land they replace this body , not
 * this file's existence."*
 *
 * They have landed. `App` owns the session, the login and the two lists;
 * this file still does exactly one thing, which is find the mount point and
 * open a root on it.
 *
 * **And it imports the stylesheet, which `P0-UIK-023` bought the hard way.**
 * The console shipped to the founder with no `.css` in its bundle at all and
 * the sitting of 28 August found a page of unstyled text. One import is the
 * whole cure, and the build's own asset list is the check: a `dist/assets`
 * holding a `.js` and no `.css` is that defect, exactly.
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

createRoot(racine).render(<App />);
